export default function (state = {}) {
  return { ...state, whatsappForm: state.cnpj?.startsWith('50221019') }
}
